import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';
import { Postbox } from '../postbox/postbox';
import '../dialog/dialog';
import moment = require("moment");
import '../address/address_form';
import { RolesAndRights } from "../../helpers/RolesAndRights";
enum AddressCategories {
    Alle = "Alle",
    Mandant = "Mandant",
    Gegner = "Gegner",
    Gericht = "Gericht"
}
export class AddressOverviewViewModel {
    infoMessage = ko.observable('');
    infoTitle = ko.observable('');
    modialAutoHide = ko.observable(false);
    addresses = ko.observableArray([]);
    mandanten = ko.observableArray([]);
    gegner = ko.observableArray([]);
    sonstige = ko.observableArray([]);
    addressCases = ko.observableArray([]);
    DropDownText = ko.observable("Mandant");
    isViewerRole = ko.observable<boolean>(false);
    statesTable = {
        0: "Nicht definiert",
        2: "Baden-Württemberg",
        3: "Bayern (EV)",
        4: "Bayern (RK)",
        5: "Berlin",
        6: "Brandenburg",
        7: "Bremen",
        8: "Hamburg",
        9: "Hessen",
        10: "Mecklenburg-Vorpommern",
        11: "Niedersachsen",
        12: "Nordrhein-Westfalen",
        13: "Rheinland-Pfalz",
        14: "Saarland",
        15: "Sachsen",
        16: "Sachsen-Anhalt",
        17: "Schleswig Holstein",
        18: "Thüringen (EV)",
        19: "Thüringen (RK)"
    };
    selectedType = ko.observable("Mandant");
    types = ko.observableArray(["Mandant", "Gegner", "Sonstige", "Gericht", "Versicherung", "Behörde", "Anwalt"]);
    requiredVertreter = ko.observableArray(["Mandant", "Gegner", "Sonstige"]);
    columns = ko.observableArray(['FirstName', 'Name1', 'CityName', 'Actions']);
    columnHeaders = ko.observableArray(['Vorname', 'Nachname', 'Ort']);
    currentCategory = ko.observable(AddressCategories.Mandant);
    categories = AddressCategories;
    currentAddress = ko.observable({
        Keyword: "",
        Sonstige1: "",
        Update: ""
    });
    IsEditMode = ko.observable(false);
    showRF = ko.observable(false);
    wantToDelete = ko.observable(true);
    notAssigned = ko.observable(false);
    rachts = ko.observableArray([]);
    rachtsPerson = ko.observableArray([]);
    briefkopf = ko.observableArray([]);
    addressScope = ko.observable(2);
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection = ko.observable();
    newPerson() {
        let obj = {
            FirstName: ko.observable(""),
            Name1: ko.observable(""),
            Name2: ko.observable(""),
            Name3: ko.observable(""),
            Rechtsform: ko.observable(null),
            Address: ko.observable(null),
            ZipCode: ko.observable(null),
            CityName: ko.observable(null),
            EmailAddress: ko.observable(null),
            Phone1: ko.observable(null),
            AnredeBriefkopf: ko.observable(null),
            AnredeDirekt: ko.observable(null),
            Note1: ko.observable(null),
            GesetzlicherVertreter1Id: ko.observable(null),
            Fax: ko.observable(null),
            RSVersNr: ko.observable(null)
        };
        obj["Keyword"] = ko.computed(function () {
            return (obj.Name1() + obj.FirstName()).substring(0, 20);
        });
        return ko.observable(obj);
    }
    ;
    person = this.newPerson();
    typeChanged(obj, event) {
        if (event.originalEvent) {
            if (this.selectedType() === "Gericht") {
                this.columns(['Name1', 'CityName']);
                this.columnHeaders(['Name', 'Ort']);
            }
            else {
                this.columns(['FirstName', 'Name1', 'CityName']);
                this.columnHeaders(['Vorname', 'Name', 'Ort']);
            }
        }
    }
    async loadAssignedCases(keyword, type) {
        let res = (await RNSAPI.checkAssignment(keyword, type));
        if (res.Type === "AddressAssignedToPerson") {
            this.wantToDelete(false);
            this.notAssigned(false);
            this.addressCases(res.Payload.AssignedCases);
            $("#addressAssigned").modal("show");
        }
        else {
            this.notAssigned(true);
            $("#addressAssigned").modal("show");
        }
    }
    initTooltip() {
        try {
            $("[data-toggle='tooltip']").tooltip();
        }
        catch { }
    }
    async loadAddresses() {
        if (this.selectedType() === AddressCategories.Mandant) {
            this.addressScope(2);
        }
        else if (this.selectedType() === AddressCategories.Gegner) {
            this.addressScope(3);
        }
        else if (this.selectedType() === AddressCategories.Gericht) {
            this.addressScope(8);
        }
        await RNSAPI.getAdressPagin(ko.toJS(this.addressScope)).then((addresses) => {
            let addr = addresses as any;
            this.addresses(addr.map((a) => {
                if (a['Phone'] === '+49')
                    a['Phone'] = '';
                a.actionHandlers = [];
                if (!this.isViewerRole()) {
                    if (a.IsFavorite === true) {
                        a.actionHandlers.push({
                            icon: "star fas text-warning",
                            name: "Aus Favoriten entfernen",
                            action: () => this.setFavorite(a.Keyword, this.selectedType(), false)
                        });
                    }
                    else {
                        a.actionHandlers.push({
                            icon: "star",
                            name: "Zu Favoriten hinzufügen",
                            action: () => this.setFavorite(a.Keyword, this.selectedType(), true)
                        });
                    }
                }
                if (this.selectedType() === "Gericht") {
                    if (a.Name.includes("ýý")) {
                        return "";
                    }
                    if (this.selectedType() === "Gericht") {
                        a.State = this.statesTable[a.State];
                    }
                    a.actionHandlers.push({
                        icon: "eye",
                        name: "Ansehen",
                        action: () => this.loadPerson(a.Keyword, this.selectedType())
                    });
                }
                else {
                    if (!this.isViewerRole()) {
                        a.actionHandlers.push({
                            icon: "pencil-alt",
                            name: "Bearbeiten",
                            action: () => this.loadPerson(a.Keyword, this.selectedType())
                        }, {
                            icon: "info-circle",
                            name: "Aktenzuordnung",
                            action: async () => { this.loadAssignedCases(a.Keyword, this.selectedType()); }
                        }, {
                            icon: "trash-alt",
                            name: "Löschen",
                            action: async () => {
                                this.setCurrentAddress({
                                    Keyword: a.Keyword,
                                    Sonstige1: this.selectedType(),
                                    Update: 'addresses'
                                });
                            }
                        });
                    }
                    else {
                        a.actionHandlers.push({
                            icon: "eye",
                            name: "Ansehen",
                            action: () => this.loadPerson(a.Keyword, this.selectedType())
                        });
                    }
                }
                return a;
            }));
        }).catch((error) => {
            console.log(error);
            this.addresses([]);
        });
    }
    async deleteAddress() {
        let res = await RNSAPI.deletePerson(this.currentAddress().Keyword, this.currentAddress().Sonstige1);
        $("#deleteConfirm").modal("hide");
        if (res.Type === "AddressAssigned") {
            this.wantToDelete(true);
            this.notAssigned(false);
            this.addressCases(res.Payload.AssignedCases);
            $("#addressAssigned").modal("show");
        }
        else {
            this.loadAddresses();
        }
    }
    setCurrentAddress(address) {
        this.currentAddress(address);
        $("#deleteConfirm").modal("show");
    }
    async navigateToCase(data) {
        $('#addressAssigned').modal("hide");
        var mb = document.getElementsByClassName("modal-backdrop");
        mb[0].remove();
        MainViewModel.RoutingTable.showNewView({ caseId: data });
    }
    showMandant = () => {
        this.currentCategory(AddressCategories.Mandant);
        this.selectedType(AddressCategories.Mandant);
        localStorage.setItem('updateSelectedAddress', 'Mandant');
        this.loadAddresses();
    };
    showGegner = () => {
        this.currentCategory(AddressCategories.Gegner);
        this.selectedType(AddressCategories.Gegner);
        localStorage.setItem('updateSelectedAddress', 'Gegner');
        this.loadAddresses();
    };
    showGericht = () => {
        this.currentCategory(AddressCategories.Gericht);
        this.selectedType(AddressCategories.Gericht);
        this.loadAddresses();
    };
    async loadPerson(keyword, type) {
        let result = (await RNSAPI.getPersonForKeyword(keyword, type));
        if (result.Type === "ExactMatchNotFound") {
            alert("Person wurde in der Zwischenzeit gelöscht!");
            return;
        }
        let person = result.Payload.Address;
        let newPerson = this.newPerson();
        let obj = newPerson();
        for (let key in person) {
            if (obj[key] === undefined) {
                obj[key] = person[key];
            }
            else if (key !== "Keyword") {
                obj[key](person[key]);
            }
            else {
                obj["Keyword"] = ko.observable(person["Keyword"]);
            }
        }
        obj["Keyword"] = keyword;
        obj["Sonstige1"] = type;
        this.person(obj);
        Postbox.publisher().publish(this.person, "updateAddressModal");
        $('#allAddressModal').modal('show');
    }
    async setFavorite(keyword, type, setAsFavorite) {
        RNSAPI.setFavoriteState(keyword, type, setAsFavorite).then((res) => {
            this.loadAddresses();
        }).catch((error) => {
            alert("Es ist ein Fehler aufgetreten!");
        });
    }
    async getCity() {
        const { Type, Payload } = (await RNSAPI.getPostcode(this.person().ZipCode()));
        if (Type === "GetPostcodeResult" && Payload.Cities.length > 0) {
            this.person().CityName(Payload.Cities[0]);
        }
        else {
            this.person().CityName('');
        }
    }
    selectOption = (data) => {
        let a = ko.toJS(this.briefkopf);
        for (let i = 0; i < a.length; i++) {
            if (data === a[i].NameID) {
                this.person().Rechtsform(a[i].NameID);
                this.person().AnredeBriefkopf(a[i].Briefanrede);
                this.person().AnredeDirekt(a[i].Anrede);
                this.showRF(false);
                break;
            }
        }
    };
    pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    }
    pickRechtsform = async () => {
        let rechtsformen = (await RNSAPI.getRechtsformen()).Payload.LegalForms;
        let x = [];
        let y = [];
        let z = [];
        let a = [];
        let b = [];
        let c = [];
        for (let i = 0; i < rechtsformen.length; i++) {
            if (rechtsformen[i].NameID != "") {
                if (rechtsformen[i].NameID === "Herr" || rechtsformen[i].NameID === "Frau" || rechtsformen[i].NameID === "Divers") {
                    a.push(rechtsformen[i].NameID);
                    b.push(rechtsformen[i].Briefanrede);
                    c.push(rechtsformen[i].Anrede);
                }
                else {
                    x.push(rechtsformen[i].NameID);
                    y.push(rechtsformen[i].Briefanrede);
                    z.push(rechtsformen[i].Anrede);
                }
            }
        }
        this.rachts(x);
        this.rachtsPerson(a);
        this.briefkopf(rechtsformen);
    };
    resetObject() {
        let newPerson = this.newPerson();
        let obj = newPerson();
        return obj;
    }
    showInfoMessage() {
        setTimeout(() => {
            this.infoMessage('');
            this.modialAutoHide(true);
            $("html, body").animate({ scrollTop: 0 }, "fast");
        }, 4000);
    }
    typeToView(type) {
        if (type === "Mandant")
            this.showMandant();
        else if (type === "Gegner")
            this.showGegner();
        else if (type === "Gericht")
            this.showGericht();
    }
    constructor() {
        this.isViewerRole(RolesAndRights.isViewerRole());
        this.showMandant();
        this.initTooltip();
        Postbox.publisher().subscribe((type: string) => {
            this.currentCategory(AddressCategories[type]);
            this.selectedType(type);
        }, 'updateAddress');
        Postbox.publisher().subscribe((inf) => {
            this.infoMessage(inf.infMessage);
            this.infoTitle(inf.infTitle);
            this.modialAutoHide(inf.infshow);
            this.typeToView(ko.toJS(inf.type));
            this.showInfoMessage();
        }, 'showInfo');
    }
}
let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');
ko.components.register("addressoverview-view", {
    viewModel: AddressOverviewViewModel,
    template: html
});
